import business1 from "./images/details-1.jpg";
import business2 from "./images/details-2.jpg";
import business3 from "./images/details-3.jpg";
import business4 from "./images/details-4.jpg";
import businessffx1 from "./images/fastfix01.jpg";
import businessepos1 from "./images/epostal.jpg";
import businessepos2 from "./images/epostal2.jpg";
import businessepos3 from "./images/epostal3.jpg";
import businessrest1 from "./images/rest1.jpg";
import businessrest2 from "./images/rest2.jpg";
import businessrest3 from "./images/rest3.jpg";
import businesscoffee from "./images/coffee.jpg";
import businessautorep1 from "./images/autorep1.jpg";
import businessautorep2 from "./images/autorep2.jpg";
import businessautorep3 from "./images/autorep3.jpg";
import businessautomaint1 from "./images/automaint1.jpg";
import businessautomaint2 from "./images/automaint2.jpg";
import businessautomaint3 from "./images/automaint3.jpg";
import img1 from "./images/business-1.jpg";
import img2 from "./images/business-2.jpg";
import img3 from "./images/business-3.jpg";
import img4 from "./images/business-4.jpg";
import img5 from "./images/business-5.jpg";
import img6 from "./images/business-6.jpg";
import img7 from "./images/business-8.jpg";
import img8 from "./images/business-9.jpg";
import img9 from "./images/business-10.jpg";
import img10 from "./images/business-11.jpg";
import img11 from "./images/business-12.jpg";
// import img12 from "./images/business-12.jpg";

export default [
  {
    sys: {
      id: "1"
    },
    fields: {
      name: "Retail - Jewelry",
      slug: "retail",
      type: "retail",
      price: 75000,
      downpayment: 13500,
      grosssales: 252700,
      cashflow: 47200,
      inventoryatcost: 10000,
      mthlybuildingrent: 4500,
      typeoffinancial: "Seller Financial Statements",
      reportperiodoffinancials: 3,
      FFE: 27500,
      size: 875,
      capacity: 5,
      pets: false,
      breakfast: false,
      featured: false,
      relocatable: false,
      homebased: false,
      realestateincluded: false,
      reasonforsale: "partnership / dissolution",
      description: [
        "BUSINESS SUMMARY & DESCRIPTION ", 
        "** Price Reduced to $75, 000** MUST SELL NOW ** ",
        "Opportunity to purchase an established profitable watch and jewelry repair business that is part of the world’s largest franchise in that particular industry.  Concept was introduced over 30 years ago and has grown to 150 retail locations in the U.S.and Canada.  Always ranked by Entrepreneur’s Franchise 500. Perfected system for delivering fast, efficient, professional repair work on jewelry and watches for men and woman.  Proven system with a franchiser that will provide training, on-going support and efficient promotion and advertising methods.",
        "Having experience in this business is NOT a prerequisite for success.  Stores located conveniently in high traffic areas of regional shopping malls either in highly visible kiosks or through an inline retail front.  Services include chain smoldering, remounting, ring sizing, engraving(extremely high profit margins), jewelry cleanings, watchbands, mountings, loose stones, smart phone repair and watch batteries replacement.",
        "Financials – Seller financial statements",
        "Business hours - Monday - Saturday 11: 00 am – 9: 00 pm; Sun 12 noon – 6: 00 pm",
        "2 employees ",
        "EXTREMELY MOTIVATED SITUATION! The seller has been employed as a jeweler with the franchise as either an owner or an employee for over 30 years and is ready to retire for health reasons. This business has always made a solid income and will continue to do so but the owner has grown weary.  Ready to make a move now so please make any reasonable offer.",
        "This business needs to be operated by a younger, more businesses minded individual. The owner can be replaced by a jeweler at a pay scale of $18 - 21 / hour with a 30 - 35 hours work / week maximum.  Sale will require franchiser approval and a transfer fee of $5,000 to be paid by the buyer which will include 1 week training in all aspects of the business (room, board and airfare not included).",
        "A 6 % royalty is paid monthly based on the gross revenues and the franchisee is required to spend an additional 2 % of gross revenues on advertising in the trade / market area as defined by the franchisee.",
        "The information contained in this marketing is subject to change, corrections, or withdrawal without notice.  Information provided herein has been provided by the Seller and not by Broker.  The Seller has listed this business strictly as an asset transaction.  This is not an offer to sell securities.  This is not a solicitation to sell securities",
        "Listing Firm: Diversified Business Investments, Contact Stocker Travis, Principal at 214 - 725 - 2775 or Stocker@dbi-businessadvisors.com",
        "Lease expires April 30, 2022",
        "MARKET OUTLOOK & COMPETITION - Excellent for the right individual",
        "GROWTH POTENTIAL & EXPANSION - Outside what is required by the franchiser, the seller does little to no advertising.",
        "SUPPORT & TRAINING - Seller will train at no cost to buyer for two weeks.",
        "REASON FOR SALE - Health / retirement."
      ],
      extras: [
        "Inventory included in asking price",
        "Years established 2",
        "Hours Mon - Sat 11:00 am - 9:00 pm   Sunday 12 noon - 6:00 pm",
      ],
      images: [
        {
          fields: {
            file: {
              url: img1
            }
          }
        },
        {
          fields: {
            file: {
              url: businessffx1
            }
          }
        },
        {
          fields: {
            file: {
              url: ""
            }
          }
        },
        {
          fields: {
            file: {
              url: ""
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "2"
    },
    fields: {
      name: "food & beverage",
      slug: "food-beverage",
      type: "food & beverage",
      price: 150000,
      downpayment: 135000,
      grosssales: 400000,
      cashflow: 67000,
      inventoryatcost: 4000,
      mthlybuildingrent: 5000,
      typeoffinancial: "Seller Financial Statements",
      reportperiodoffinancials: 3000,
      FFE: 45000,
      size: 3990,
      capacity: 6,
      pets: false,
      breakfast: false,
      featured: false,
      relocatable: false,
      homebased: false,
      realestateincluded: false,
      reasonforsale: "retirement",
      description:
      ["unavailable for now"],
      extras: [
        ""
      ],
      images: [
        {
          fields: {
            file: {
              url: img2
            }
          }
        },
        {
          fields: {
            file: {
              url: businessrest1
            }
          }
        },
        {
          fields: {
            file: {
              url: businessrest2
            }
          }
        },
        {
          fields: {
            file: {
              url: businessrest3
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "3"
    },
    fields: {
      name: "food & beverage",
      slug: "food-beverage",
      type: "food & beverage",
      price: 250000,
      downpayment: 135000,
      grosssales: 400000,
      cashflow: 67000,
      inventoryatcost: 4000,
      mthlybuildingrent: 5000,
      typeoffinancial: "Seller Financial Statements",
      reportperiodoffinancials: 3000,
      FFE: 45000,
      size: 3990,
      capacity: 5,
      pets: false,
      breakfast: false,
      featured: false,
      relocatable: false,
      homebased: false,
      realestateincluded: false,
      reasonforsale: "partnership dissolution",
      description:
        ["No details yet."],
      extras: [
        ""
      ],
      images: [
        {
          fields: {
            file: {
              url: img3
            }
          }
        },
        {
          fields: {
            file: {
              url: businessrest1
            }
          }
        },
        {
          fields: {
            file: {
              url: businessrest2
            }
          }
        },
        {
          fields: {
            file: {
              url: businessrest3
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "4"
    },
    fields: {
      name: "food & beverage",
      slug: "food-beverage-N. Dallas",
      type: "food & beverage",
      price: 650000,
      downpayment: 650000,
      grosssales: 380000,
      cashflow: 199900,
      inventoryatcost: 4000,
      mthlybuildingrent: 4000,
      typeoffinancial: "Seller Financial Statements",
      reportperiodoffinancials: 3,
      FFE: 150000,
      size: 572,
      capacity: 7,
      pets: false,
      breakfast: false,
      featured: false,
      relocatable: false,
      homebased: false,
      realestateincluded: false,
      reasonforsale: "changing careers",
      description:
    ['BUSINESS SUMMARY & DESCRIPTION - Coffee Shop for Sale in North Dallas- Starbucks brand - Serious Cash Buyers Only  Unique opportunity.Located in major hotel chain.Must have food & beverage experience and provide proof of ability to purchase.Financials from Seller Financial Statements  Business hours Monday – Sunday 6: 00 a.m.– 8: 00 p.m. 4 Employees.The information contained in this marketing is subject to change, corrections, or withdrawal without notice.Information provided herein has been provided by the Seller and not by Broker.The Seller has listed this business strictly as an asset transaction.This is not an offer to sell securities.This is not a solicitation to sell securities.Listing Business Broker Firm: Diversified Business Investments.Contact Stocker Travis, Principal at 214 - 725 - 2775 or Stocker@libertyexchange.com  FACILITIES - Approximately 572 sq.ft., $4, 000 Monthly Rent.Lease expires December 31, 2025.  Contact Email: stocker@libertyexchange.com'],
      extras: [
        ""
      ],
      images: [
        {
          fields: {
            file: {
              url: img4
            }
          }
        },
        {
          fields: {
            file: {
              url: businesscoffee
            }
          }
        },
        {
          fields: {
            file: {
              url: ""
            }
          }
        },
        {
          fields: {
            file: {
              url: ""
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "5"
    },
    fields: {
      name: "mail and shipping",
      slug: "mail-shipping",
      type: "mail-shipping",
      price: 45000,
      downpayment: 45000,
      grosssales: 137200,
      cashflow: 12900,
      inventoryatcost: 3500,
      mthlybuildingrent: 2000,
      typeoffinancial: "Seller Financial Statements",
      reportperiodoffinancials: 3,
      FFE: 15000,
      size: 1125,
      capacity:"3",
      pets: false,
      breakfast: false,
      featured: false,
      relocatable: false,
      homebased: false,
      realestateincluded: false,
      reasonforsale: "retirement",
      description:
        ["BUSINESS SUMMARY & DESCRIPTION - Established, profitable mail center located in a well-traveled shopping center in north Dallas close to Valley View Lane & Josey Lane in Farmers Branch, TX. Established, repeat clientele. Great demographic for this type of business. Fairly easy to operate (short hours, limited equipment, inventory & labor). Business currently run full time by the owner with no employees. In 2007 the business was originally located in the Tom Thumb center at the southeast corner of Spring Valley Rd. & Marsh Lane and was moved to the current location in January/2013. Extreme upside to expand the leasehold into space available next door and increase sales with on-site, full-service printing services as well as fulfillment and bulk mailing services all of which the current owner does not offer to the existing customer base.  Sales revenues include worldwide tracking & shipping. Shippers include Federal Express (FedEx), United Parcel Service (UPS), DHL, US Postal Service (USPS), Lone Star Overnight (LSO) and International Package Shipping (IPS). The business offers a wide variety of services including custom packaging services, private mailbox rentals, various services (copies, fax sending & receiving, mail processing services, notary public) and retail products (stamps, cardboard boxes, office products/supplies, greeting cards, mailing/ packing/moving supplies, maps, rubber stamps, business cards, unique gift & novelty items). Business also offers computer repair services, video & film conversion and purchases used calculators, clickers and text books all through outside third parties.  Mailbox rental very profitable revenue source. There is a total of 210 small, medium and large mailboxes available of which approx. 32% are currently rented out.  Business also offers digital mailbox services to customers which is extremely useful to business owners who desire to receive as well as forward mail, scan, shred or fax documents, deposit checks, route packages and have all such activities communicated to them by email.  PRICED TO SELL QUICKLY BEFORE HOLIDAY RUSH!!  Extremely motivated situation! Seller at retirement age and will consider all reasonable offers!!  Business may be shown at any time during normal business hours. Not a confidential sale but owner has requested to keep the conversation to a minimum when in front of customers.  Business Hours - Monday - Friday 9:00 am – 6:00 pm; Sat 9:00 am – 1:00 pm  The information contained in this marketing is subject to change, corrections, or withdrawal without notice. Information provided herein has been provided by the Seller and not by Broker.  The Seller has listed this business strictly as an asset transaction. This is not an offer to sell securities. This is not a solicitation to sell securities.  Listing Business Broker Firm: Diversified Business Investments. Contact Stocker Travis, Principal at 214-725-2775 or Stocker@libertyexchange.com  FACILITIES – Monthly Bldg Rent $1,987.21; Approximately 1,125 sq.ft.; Lease expires October 31, 2020.  MARKET OUTLOOK & COMPETITION - The COVID pandemic has affected the shipping business in a positive way. Sales are up 26% over last year through September/2020. Sales revenue will easily top $170K in 2020 over $117K in 2019. Virtually no competition in the immediate area.  GROWTH POTENTIAL & EXPANSION - Suggest buyer joins Retail Shipping Associates as a premium member to gain access to a variety of services and products to add including passport & identity photos, passport expediting, large format printing (banners, signs, blueprints, etc.), larger selection of greeting cards & other retail items, delivery services, additional digital or virtual mailbox services and become a Package Business Center.  SUPPORT & TRAINING - Seller will train at no cost to buyer for one to two weeks as needed  REASONS FOR SALE - Health issues/Retirement  Contact Email: stocker@libertyexchange.com"],
      extras: [
        ""
      ],
      images: [
        {
          fields: {
            file: {
              url: img5
            }
          }
        },
        {
          fields: {
            file: {
              url: businessepos1
            }
          }
        },
        {
          fields: {
            file: {
              url: businessepos2
            }
          }
        },
        {
          fields: {
            file: {
              url: businessepos3
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "6"
    },
    fields: {
      name: "motorcycle repair",
      slug: "motocycle-repair",
      type: "repair svcs",
      price: 250000,
      downpayment: 135000,
      grosssales: 400000,
      cashflow: 67500,
      inventoryatcost: 4000,
      mthlybuildingrent: 5000,
      typeoffinancial: "Seller Financial Statements",
      reportperiodoffinancials: 3,
      FFE: 45000,
      size: 3990,
      capacity: 7,
      pets: false,
      breakfast: false,
      featured: false,
      relocatable: false,
      homebased: false,
      realestateincluded: false,
      reasonforsale: "partnership / dissolution",
      description:
        ["Not available yet"],
      extras: [
        ""
      ],
      images: [
        {
          fields: {
            file: {
              url: img6
            }
          }
        },
        {
          fields: {
            file: {
              url: business2
            }
          }
        },
        {
          fields: {
            file: {
              url: business3
            }
          }
        },
        {
          fields: {
            file: {
              url: business4
            }
          }
        }
      ]
    }
  },
  /* {
    sys: {
      id: "7"
    },
    fields: {
      name: "franchise",
      slug: "franchise-childcare",
      type: "franchise-childcare",
      price: 300000,
      downpayment: 65000,
      grosssales: 40000,
      cashflow: 50000,
      inventoryatcost: 4000,
      mthlybuildingrent: 5200,
      typeoffinancial: "Seller Financial Statements",
      reportperiodoffinancials: 3,
      FFE: 24000,
      size: 1990,
      capacity: 5,
      pets: false,
      breakfast: false,
      featured: false,
      relocatable: false,
      homebased: false,
      realestateincluded: false,
      reasonforsale: "partnership / dissolution",
      description:
        ["Not available yet"],
      extras: [
        ""
      ],
      images: [
        {
          fields: {
            file: {
              url: img7
            }
          }
        },
        {
          fields: {
            file: {
              url: business2
            }
          }
        },
        {
          fields: {
            file: {
              url: business3
            }
          }
        },
        {
          fields: {
            file: {
              url: business4
            }
          }
        }
      ]
    }
  } */
  {
    sys: {
      id: "7"
    },
    fields: {
      name: "retail-Laundromat",
      slug: "retail-laundromat",
      type: "retail-Laundromat",
      price: 400000,
      downpayment: 135000,
      grosssales: 400000,
      cashflow: 67500,
      inventoryatcost: 4000,
      mthlybuildingrent: 5000,
      typeoffinancial: "Seller Financial Statements",
      reportperiodoffinancials: 3,
      FFE: 45000,
      size: 3990,
      capacity: 4,
      pets: false,
      breakfast: false,
      featured: false,
      relocatable: false,
      homebased: false,
      realestateincluded: false,
      reasonforsale: "downsizing",
      description:
        ["Currently not available"],
      extras: [
        ""
      ],
      images: [
        {
          fields: {
            file: {
              url: img7
            }
          }
        },
        {
          fields: {
            file: {
              url: business2
            }
          }
        },
        {
          fields: {
            file: {
              url: business3
            }
          }
        },
        {
          fields: {
            file: {
              url: business4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "8"
    },
    fields: {
      name: "automotive parts",
      slug: "automotive-parts",
      type: "automotive",
      price: 300000,
      downpayment: 135000,
      grosssales: 400000,
      cashflow: 67500,
      inventoryatcost: 4000,
      mthlybuildingrent: 5000,
      typeoffinancial: "Seller Financial Statements",
      reportperiodoffinancials: 3000,
      FFE: 45000,
      size: 4090,
      capacity: 10,
      pets: false,
      breakfast: false,
      featured: false,
      relocatable: false,
      homebased: false,
      realestateincluded: false,
      reasonforsale: "partnership - dissolution",
      description:
        ["Information to come"],
      extras: [
        ""
      ],
      images: [
        {
          fields: {
            file: {
              url: img8
            }
          }
        },
        {
          fields: {
            file: {
              url: businessautomaint1
            }
          }
        },
        {
          fields: {
            file: {
              url: businessautomaint2
            }
          }
        },
        {
          fields: {
            file: {
              url: businessautomaint3
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "9"
    },
    fields: {
      name: "automotive detailing",
      slug: "automotive-detailing",
      type: "automotive",
      price: 350000,
      downpayment: 100000,
      grosssales: 300000,
      cashflow: 70500,
      inventoryatcost: 12000,
      mthlybuildingrent: 4000,
      typeoffinancial: "Seller Financial Statements",
      reportperiodoffinancials: 3,
      FFE: 5000,
      size: 2990,
      capacity: 10,
      pets: false,
      breakfast: false,
      featured: true,
      relocatable: false,
      homebased: false,
      realestateincluded: false,
      reasonforsale: "partnership / dissolution",
      description:
        ["Information available soon"],
      extras: [
        ""
      ],
      images: [
        {
          fields: {
            file: {
              url: img9
            }
          }
        },
        {
          fields: {
            file: {
              url: businessautomaint1
            }
          }
        },
        {
          fields: {
            file: {
              url: businessautomaint2
            }
          }
        },
        {
          fields: {
            file: {
              url: businessautomaint3
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "10"
    },
    fields: {
      name: "automotive repair",
      slug: "automotive-repair",
      type: "automotive",
      price: 400000,
      downpayment: 135000,
      grosssales: 400000,
      cashflow: 67500,
      inventoryatcost: 4000,
      mthlybuildingrent: 5000,
      typeoffinancial: "Seller Financial Statements",
      reportperiodoffinancials: 3,
      FFE: 45000,
      size: 3990,
      capacity: 6,
      pets: false,
      breakfast: false,
      featured: true,
      relocatable: false,
      homebased: false,
      realestateincluded: false,
      reasonforsale: "partnership / dissolution",
      description:
      ["Information available soon"],
      extras: [
        ""
      ],
      images: [
        {
          fields: {
            file: {
              url: img10
            }
          }
        },
        {
          fields: {
            file: {
              url: businessautorep1
            }
          }
        },
        {
          fields: {
            file: {
              url: businessautorep2
            }
          }
        },
        {
          fields: {
            file: {
              url: businessautorep3
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "11"
    },
    fields: {
      name: "auto maintenance",
      slug: "automotive-maintenance",
      type: "automotive",
      price: 500000,
      downpayment: 135000,
      grosssales: 400000,
      cashflow: 67500,
      inventoryatcost: 4000,
      mthlybuildingrent: 5000,
      typeoffinancial: "Seller Financial Statements",
      reportperiodoffinancials: 3,
      FFE: 45000,
      size: 3990,
      capacity: 10,
      pets: false,
      breakfast: false,
      featured: false,
      relocatable: false,
      homebased: false,
      realestateincluded: false,
      reasonforsale: "retirement",
      description:
        [""],
      extras: [
        "",
      ],
      images: [
        {
          fields: {
            file: {
              url: img11
            }
          }
        },
        {
          fields: {
            file: {
              url: businessautorep1
            }
          }
        },
        {
          fields: {
            file: {
              url: businessautorep2
            }
          }
        },
        {
          fields: {
            file: {
              url: businessautorep3
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "12"
    },
    fields: {
      name: "winery",
      slug: "winery-business",
      type: "winery",
      price: 600000,
      downpayment: 235000,
      grosssales: 200000,
      cashflow: 100000,
      inventoryatcost: 4000,
      mthlybuildingrent: 0,
      typeoffinancial: "Seller Financial Statements",
      reportperiodoffinancials: 5,
      FFE: 35000,
      size: 3990,
      capacity: 3,
      pets: false,
      breakfast: false,
      featured: true,
      relocatable: false,
      homebased: false,
      realestateincluded: true,
      reasonforsale: "downsizing",     
      description:
        ["Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression. Le Lorem Ipsum est le faux texte standard de l'imprimerie depuis les années 1500, quand un imprimeur anonyme assembla ensemble des morceaux de texte pour réaliser un livre spécimen de polices de texte. Il n'a pas fait que survivre cinq siècles, mais s'est aussi adapté à la bureautique informatique, sans que son contenu n'en soit modifié. Il a été popularisé dans les années 1960 grâce à la vente de feuilles Letraset contenant des passages du Lorem Ipsum, et, plus récemment, par son inclusion dans des applications de mise en page de texte"],
      extras: [
        "Years established 20",
        "Seller will train at no cost to buyer for two weeks",
        "Cash flow is discretionary earnings",
        "Motivated Sellers",
        "Mature business model in niche industry",
        "Includes import business",
        "Possible expension of lines of business through internet"
      ],
      images: [
        {
          fields: {
            file: {
              url: business1
            }
          }
        },
        {
          fields: {
            file: {
              url: business2
            }
          }
        },
        {
          fields: {
            file: {
              url: business3
            }
          }
        },
        {
          fields: {
            file: {
              url: business4
            }
          }
        }
      ]
    }
  }
];
